import {useState, useEffect, type MutableRefObject} from 'react'

import {useIntersectionObserver} from '@github-ui/use-sticky-header/useIntersectionObserver'

export const useCurrentVisibleHeading = (options: {ref: MutableRefObject<HTMLDivElement | null>}) => {
  const [currVisibleHeading, setCurrVisibleHeading] = useState<string | undefined>()

  const [observe, unobserve] = useIntersectionObserver(
    entries => {
      const intersecting = entries.find(entry => entry.isIntersecting)

      if (intersecting === undefined || typeof intersecting.target.id !== 'string') {
        return
      }

      setCurrVisibleHeading(intersecting.target.id)
    },
    {
      threshold: 0.75,
    },
  )

  useEffect(() => {
    if (options.ref.current === null) {
      return
    }

    /**
     * Get all the headings in the scope of the ref, which should be the content container.
     */
    const headings = Array.from(options.ref.current.querySelectorAll(':scope h2[id], :scope h3[id], :scope h4[id]'))

    for (const heading of headings) {
      observe(heading)
    }

    return () => {
      for (const heading of headings) {
        unobserve(heading)
      }
    }
  }, [options.ref, observe, unobserve])

  return currVisibleHeading
}
